import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

class InvoiceStatusBadge extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            status: this.props.status || '',
            style: this.props.style || {},
            refunded: this.props.refunded || false,
        }
        this.className = this.props.className || ''
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            status: nextProps.status || '',
            style: nextProps.style || {},
        })
    }

    renderStatus() {
       /*  const refundedBadge = this.state.refunded ? <div className="badge badge-warning text-with-icon ml-2">
            <FormattedMessage
                id="invoice.status.refunded_label"
                defaultMessage="Refunded"
            />
        </div> : '' */
        const refundedBadge = ''

        switch (this.state.status) {
            case 'draft':
                return <div className="badge badge-primary text-with-icon">
                    <FormattedMessage
                        id="invoice.status.draft_label"
                        defaultMessage="Draft"
                    />
                </div>
            case 'sent':
                return <span>
                    <div className="badge badge-info text-with-icon">
                        <FormattedMessage
                            id="invoice.status.waiting_for_payment_label"
                            defaultMessage="Waiting for payment"
                        />
                    </div>
                    {refundedBadge}
                </span>
            case 'partially-paid':
                return <span>
                    <div className="badge badge-warning text-with-icon">
                        <FormattedMessage
                            id="invoice.status.partially_paid_label"
                            defaultMessage="Partially paid"
                        />
                    </div>
                    {refundedBadge}
                </span>
            case 'fully-paid':
                return <span>
                    <div className="badge badge-success text-with-icon">
                        <FormattedMessage
                            id="invoice.status.fully_paid_label"
                            defaultMessage="Fully paid"
                        />
                    </div>
                    {refundedBadge}
                </span>
            case 'voided':
                return <div className="badge badge-danger text-with-icon">
                    <FormattedMessage
                        id="invoice.status.voided_label"
                        defaultMessage="Voided"
                    />
                </div>
            case 'active':
                return <div className="badge badge-success text-with-icon">
                    <FormattedMessage
                        id="invoice.status.active_label"
                        defaultMessage="Active"
                    />
                </div>
            case 'inactive':
                return <div className="badge badge-secondary text-with-icon">
                    <FormattedMessage
                        id="invoice.status.inactive_label"
                        defaultMessage="Inactive"
                    />
                </div>
            case 'finished':
                return <div className="badge badge-custom-primary text-with-icon">
                    <FormattedMessage
                        id="invoice.status.finished_label"
                        defaultMessage="Finished"
                    />
                </div>
        }
        return <div></div>
    }

    render() {
        return <span className={this.className} style={this.state.style}>
            {this.renderStatus()}
        </span>
    }

}

export default InvoiceStatusBadge





// WEBPACK FOOTER //
// ./src/invoice/status.component.jsx